<template>
  <div>
    <section class="search-container">
      <div class="flex">
        <div class="name">产品大类</div>
        <el-select
          v-model="productClass"
          placeholder="请选择"
          filterable
          clearable
        >
          <el-option
            v-for="item in proClassList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
      <div class="flex">
        <div class="name">收货地址</div>
        <el-select v-model="shdz" placeholder="请选择" filterable clearable>
          <el-option
            v-for="item in dizhiList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
      <div class="flex">
        <div class="name">分销商</div>
        <el-select v-model="fxs" placeholder="请选择" filterable clearable>
          <el-option
            v-for="item in fxsList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
      <div class="flex">
        <div class="name">销售类别</div>
        <el-select v-model="sellType" placeholder="请选择" filterable clearable>
          <el-option
            v-for="item in leibieList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>

      <div class="flex">
        <div class="name">下单时间</div>

        <el-select
          @change="changeTime"
          v-model="timeFlag"
          placeholder="请选择"
          filterable
          clearable
          v-if="flag"
        >
          <el-option
            v-for="item in timeList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>

        <el-date-picker
          v-else
          @change="changeStartEnd"
          v-model="time"
          type="daterange"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="YYYY-MM-DD"
        >
        </el-date-picker>
      </div>
      <div class="flex">
        <el-button @click="getList" type="danger" style="background: #f42434"
          >查询</el-button
        >
        <el-button @click="reset">重置</el-button>
        <el-button @click="daochu" type="primary" style="background:#f78989;border-color:#f78989">导出</el-button>
      </div>
    </section>
    <el-table :data="list" border stripe>
      <el-table-column label="状态名称">
        <el-table-column prop="name" label="子状态名称"> </el-table-column>
      </el-table-column>
      <el-table-column label="合计">
        <el-table-column label="子状态合计" prop="99">
          <template #default="scope">
            <el-popover
              placement="top-start"
              :title="scope.row['name']"
              :width="200"
              trigger="hover"
              :content="scope.row['99']"
            >
              <template #reference>
                <section class="name-wrapper">{{ scope.row["99"] }}</section>
              </template>
            </el-popover>

            <!-- <span class="name-wrapper">
              {{ scope.row["99"] }}
            </span> -->
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="下单状态">
        <el-table-column label="制单中" prop="1">
          <template #default="scope">
            <el-popover
              placement="top-start"
              :title="scope.row['name']"
              :width="200"
              trigger="hover"
              :content="scope.row['1']"
            >
              <template #reference>
                <section @click="go(scope)" class="name-wrapper">{{ scope.row["1"] }}</section>
              </template>
            </el-popover>
          </template>
    
        </el-table-column>
      </el-table-column>
      <el-table-column label="订单评审状态">
        <el-table-column prop="2" label="评审中">
           <template #default="scope">
            <el-popover
              placement="top-start"
              :title="scope.row['name']"
              :width="200"
              trigger="hover"
              :content="scope.row['2']"
            >
              <template #reference>
                <section @click="go(scope)" class="name-wrapper">{{ scope.row["2"] }}</section>
              </template>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="3" label="已评审">
           <template #default="scope">
            <el-popover
              placement="top-start"
              :title="scope.row['name']"
              :width="200"
              trigger="hover"
              :content="scope.row['3']"
            >
              <template #reference>
                <section @click="go(scope)" class="name-wrapper">{{ scope.row["3"] }}</section>
              </template>
            </el-popover>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="生产完成状态">
        <el-table-column prop="4" label="生产中">
            <template #default="scope">
            <el-popover
              placement="top-start"
              :title="scope.row['name']"
              :width="200"
              trigger="hover"
              :content="scope.row['4']"
            >
              <template #reference>
                <section @click="go(scope)" class="name-wrapper">{{ scope.row["4"] }}</section>
              </template>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="5" label="生产已完成">
            <template #default="scope">
            <el-popover
              placement="top-start"
              :title="scope.row['name']"
              :width="200"
              trigger="hover"
              :content="scope.row['5']"
            >
              <template #reference>
                <section @click="go(scope)" class="name-wrapper">{{ scope.row["5"] }}</section>
              </template>
            </el-popover>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="安排发货状态">
        <el-table-column prop="6" label="安排发货中">
         <template #default="scope">
            <el-popover
              placement="top-start"
              :title="scope.row['name']"
              :width="200"
              trigger="hover"
              :content="scope.row['6']"
            >
              <template #reference>
                <section @click="go(scope)" class="name-wrapper">{{ scope.row["6"] }}</section>
              </template>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="7" label="已安排发货">
            <template #default="scope">
            <el-popover
              placement="top-start"
              :title="scope.row['name']"
              :width="200"
              trigger="hover"
              :content="scope.row['7']"
            >
              <template #reference>
                <section @click="go(scope)" class="name-wrapper">{{ scope.row["7"] }}</section>
              </template>
            </el-popover>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="运输派车状态">
        <el-table-column prop="8" label="派车中">
             <template #default="scope">
            <el-popover
              placement="top-start"
              :title="scope.row['name']"
              :width="200"
              trigger="hover"
              :content="scope.row['8']"
            >
              <template #reference>
                <section @click="go(scope)" class="name-wrapper">{{ scope.row["8"] }}</section>
              </template>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="9" label="已派车">
            <template #default="scope">
            <el-popover
              placement="top-start"
              :title="scope.row['name']"
              :width="200"
              trigger="hover"
              :content="scope.row['9']"
            >
              <template #reference>
                <section @click="go(scope)" class="name-wrapper">{{ scope.row["9"] }}</section>
              </template>
            </el-popover>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="车辆进厂状态">
        <el-table-column prop="10" label="未进厂">
            <template #default="scope">
            <el-popover
              placement="top-start"
              :title="scope.row['name']"
              :width="200"
              trigger="hover"
              :content="scope.row['10']"
            >
              <template #reference>
                <section @click="go(scope)" class="name-wrapper">{{ scope.row["10"] }}</section>
              </template>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="11" label="进厂装车中">
             <template #default="scope">
            <el-popover
              placement="top-start"
              :title="scope.row['name']"
              :width="200"
              trigger="hover"
              :content="scope.row['11']"
            >
              <template #reference>
                <section @click="go(scope)" class="name-wrapper">{{ scope.row["11"] }}</section>
              </template>
            </el-popover>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="车辆出厂状态">
        <!-- <el-table-column prop="12" label="未出厂">
            <template #default="scope">
            <el-popover
              placement="top-start"
              :title="scope.row['name']"
              :width="200"
              trigger="hover"
              :content="scope.row['12']"
            >
              <template #reference>
                <section @click="go(scope)" class="name-wrapper">{{ scope.row["12"] }}</section>
              </template>
            </el-popover>
          </template>
        </el-table-column> -->
        <el-table-column prop="13" label="已出厂">
        <template #default="scope">
            <el-popover
              placement="top-start"
              :title="scope.row['name']"
              :width="200"
              trigger="hover"
              :content="scope.row['13']"
            >
              <template #reference>
                <section @click="go(scope)" class="name-wrapper">{{ scope.row["13"] }}</section>
              </template>
            </el-popover>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="在途状态">
        <el-table-column prop="14" label="成员企业调拨">
             <template #default="scope">
            <el-popover
              placement="top-start"
              :title="scope.row['name']"
              :width="200"
              trigger="hover"
              :content="scope.row['14']"
            >
              <template #reference>
                <section @click="go(scope)" class="name-wrapper">{{ scope.row["14"] }}</section>
              </template>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          prop="15"
          label="
配送站

"
        >
            <template #default="scope">
            <el-popover
              placement="top-start"
              :title="scope.row['name']"
              :width="200"
              trigger="hover"
              :content="scope.row['15']"
            >
              <template #reference>
                <section @click="go(scope)" class="name-wrapper">{{ scope.row["15"] }}</section>
              </template>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="16" label="在途中">
             <template #default="scope">
            <el-popover
              placement="top-start"
              :title="scope.row['name']"
              :width="200"
              trigger="hover"
              :content="scope.row['16']"
            >
              <template #reference>
                <section @click="go(scope)" class="name-wrapper">{{ scope.row["16"] }}</section>
              </template>
            </el-popover>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column prop="address" label="舍货状态">
        <el-table-column prop="17" label="部分舍货">
            <template #default="scope">
            <el-popover
              placement="top-start"
              :title="scope.row['name']"
              :width="200"
              trigger="hover"
              :content="scope.row['17']"
            >
              <template #reference>
                <section @click="go(scope)" class="name-wrapper">{{ scope.row["17"] }}</section>
              </template>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="18" label="已舍货">
            <template #default="scope">
            <el-popover
              placement="top-start"
              :title="scope.row['name']"
              :width="200"
              trigger="hover"
              :content="scope.row['18']"
            >
              <template #reference>
                <section @click="go(scope)" class="name-wrapper">{{ scope.row["18"] }}</section>
              </template>
            </el-popover>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="到货状态">
        <el-table-column prop="19" label="未签收">
            <template #default="scope">
            <el-popover
              placement="top-start"
              :title="scope.row['name']"
              :width="200"
              trigger="hover"
              :content="scope.row['19']"
            >
              <template #reference>
                <section @click="go(scope)" class="name-wrapper">{{ scope.row["19"] }}</section>
              </template>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="20" label="已到货签收">
             <template #default="scope">
            <el-popover
              placement="top-start"
              :title="scope.row['name']"
              :width="200"
              trigger="hover"
              :content="scope.row['20']"
            >
              <template #reference>
                <section @click="go(scope)" class="name-wrapper">{{ scope.row["20"] }}</section>
              </template>
            </el-popover>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="开具发票状态">
        <el-table-column prop="21" label="未开票">
             <template #default="scope">
            <el-popover
              placement="top-start"
              :title="scope.row['name']"
              :width="200"
              trigger="hover"
              :content="scope.row['21']"
            >
              <template #reference>
                <section @click="go(scope)" class="name-wrapper">{{ scope.row["21"] }}</section>
              </template>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="22" label="已开票">
             <template #default="scope">
            <el-popover
              placement="top-start"
              :title="scope.row['name']"
              :width="200"
              trigger="hover"
              :content="scope.row['22']"
            >
              <template #reference>
                <section @click="go(scope)" class="name-wrapper">{{ scope.row["22"] }}</section>
              </template>
            </el-popover>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="发票邮寄状态">
        <el-table-column prop="23" label="未邮寄">
         <template #default="scope">
            <el-popover
              placement="top-start"
              :title="scope.row['name']"
              :width="200"
              trigger="hover"
              :content="scope.row['23']"
            >
              <template #reference>
                <section @click="go(scope)" class="name-wrapper">{{ scope.row["23"] }}</section>
              </template>
            </el-popover>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="24" label="邮寄中">
         <template #default="scope">
            <el-popover
              placement="top-start"
              :title="scope.row['name']"
              :width="200"
              trigger="hover"
              :content="scope.row['24']"
            >
              <template #reference>
                <section @click="go(scope)" class="name-wrapper">{{ scope.row["24"] }}</section>
              </template>
            </el-popover>
          </template>
        </el-table-column> -->
        <el-table-column prop="25" label="已邮寄">
          <template #default="scope">
            <el-popover
              placement="top-start"
              :title="scope.row['name']"
              :width="200"
              trigger="hover"
              :content="scope.row['25']"
            >
              <template #reference>
                <section @click="go(scope)" class="name-wrapper">{{ scope.row["25"] }}</section>
              </template>
            </el-popover>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="回款状态">
        <el-table-column prop="26" label="未到期未回款">
           <template #default="scope">
            <el-popover
              placement="top-start"
              :title="scope.row['name']"
              :width="200"
              trigger="hover"
              :content="scope.row['26']"
            >
              <template #reference>
                <section @click="go(scope)" class="name-wrapper">{{ scope.row["26"] }}</section>
              </template>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="27" label="已到期未回款">
          <template #default="scope">
            <el-popover
              placement="top-start"
              :title="scope.row['name']"
              :width="200"
              trigger="hover"
              :content="scope.row['27']"
            >
              <template #reference>
                <section @click="go(scope)" class="name-wrapper">{{ scope.row["27"] }}</section>
              </template>
            </el-popover>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="28" label="已回款">
           <template #default="scope">
            <el-popover
              placement="top-start"
              :title="scope.row['name']"
              :width="200"
              trigger="hover"
              :content="scope.row['28']"
            >
              <template #reference>
                <section @click="go(scope)" class="name-wrapper">{{ scope.row["28"] }}</section>
              </template>
            </el-popover>
          </template>
        </el-table-column> -->
      </el-table-column>
    </el-table>
  </div>
</template>
<style lang="scss">
.name-wrapper {
  overflow: hidden;
  font-size: 12px;
  text-overflow: ellipsis; //超出部分以省略号显示
  white-space: nowrap;
  cursor: pointer;
}
.el-table--scrollable-x .el-table__body-wrapper {
  overflow-y: hidden;
}
.el-table .cell {
  word-break: normal;
  padding-left: 0;
}
.el-table th > .cell {
  text-align: center;
}//表头居中
.el-table td:first-child div {
  text-align: left;
}//文字居左
.el-table td div {
  text-align: right;
}//数字居右
</style>
<style lang="scss" scoped>
.search-container {
  display: flex;
  flex-wrap: wrap;
  //   border:1px solid #f0f0f0;
  padding: 10px;
  box-sizing: border-box;
  margin-bottom: 20px;
}
.flex {
  display: flex;
  align-items: center;
  margin-right: 20px;
  margin-bottom: 10px;
  .name {
    margin-right: 10px;
  }
}
.cell > div {
  cursor: pointer;
}
</style>
<script>
export default {
  methods: {
    daochu(){

      this.$axios
        .postReq("/meide/REST/ajaxOrderExport", {
          postType: "exportFirstLevel",
          productClass: this.productClass,
          shdz: this.shdz,
          fxs: this.fxs,
          sellType: this.sellType,
          timeFlag: this.timeFlag,
          startTime: this.startTime,
          endTime: this.endTime,
        })
        .then((res) => {
   
          if (res.success == "true") {
            let url=res.url
        window.open(url);
          } else {
            // this.$message.error(res.ErrorText);
          }
        });
    },
    go(scope) {
      // productClass: this.productClass,
      //     shdz: this.shdz,
      //     fxs: this.fxs,
      //     sellType: this.sellType,
      //     timeFlag: this.timeFlag,
      //     startTime,
      //     endTime,
      // let obj={}
      //    if(this.productClass){
      //       obj.productClass=this.productClass
      //    }
      //    if()
      let id = Number(scope.column.property);
      let name = ""; //要跳转的路由

      //跳到订单状态表
      if (id < 6) {
        name = "OrderStatus";
      }
      //跳到发货单状态表
      if (id >= 6 && id <= 20) {
        name = "OrderSendStatus";
      }
      //跳到发票状态表
      if (id > 20 && id < 26) {
        name = "InvoiceStatus";
      }
      //跳到回款状态
      if (id >= 26) {
        name = "HuikuanStatus";
      }

      const path = this.$router.resolve({
        name,
        params: {
          id,
        },
        query: {
          productClass: this.productClass,
          shdz: this.shdz,
          fxs: this.fxs,
          sellType: this.sellType,
          timeFlag: this.timeFlag,
          startTime: this.startTime,
          endTime: this.endTime,
        },
      });
      window.open(path.href, "_blank");

      //  this.$router.push({
      //    name:'OrderStatus',
      //    params:{
      //      id:scope.column.property
      //    }
      //  })
    },
    changeTime(val) {
      if (val == 5) {
        this.timeFlag = "";
        this.flag = false;
      }
    },
    reset() {
      this.timeFlag = "";
      this.time = "";
      this.flag = true;
      this.fxs = "";
      this.sellType = "";
      this.shdz = "";
      this.productClass = "";
    },
    getList() {
      // let startTime = "";
      // let endTime = "";
      // if (this.time) {
      //   startTime = this.time[0];
      //   endTime = this.time[1];
      // }
      this.$axios
        .postReq("/meide/REST/ajaxOrderReport", {
          postType: "queryOrderStatistics",
          productClass: this.productClass,
          shdz: this.shdz,
          fxs: this.fxs,
          sellType: this.sellType,
          timeFlag: this.timeFlag,
          startTime: this.startTime,
          endTime: this.endTime,
        })
        .then((res) => {
          if (res.success == "true") {
            if (res.data.length > 0) {
              let ary = [
                { name: "订单笔数" },
                { name: "重量/吨" },
                { name: "金额/元" },
              ];
              let data = res.data;
              data.map((item) => {
                ary[0][item["state"]] = item.num;
                ary[1][item["state"]] = item.weight;
                ary[2][item["state"]] = item.money;
              });

              this.list = ary;
            } else {
              this.list = [];
            }
          } else {
            // this.$message.error(res.ErrorText);
          }
        });
    },
    //获取产品大类列表
    init() {
      //产品大类
      this.$axios
        .postReq("/meide/REST/ajaxOrderReport", {
          postType: "queryProductClass",
        })
        .then((res) => {
          this.proClassList = res.data;
        });
      //收货地址
      this.$axios
        .postReq("/meide/REST/ajaxOrderReport", {
          postType: "queryShdz",
        })
        .then((res) => {
          this.dizhiList = res.data;
        });
      //销售类别
      this.$axios
        .postReq("/meide/REST/ajaxOrderReport", {
          postType: "querySellType",
        })
        .then((res) => {
          this.leibieList = res.data;
        });
      //分销商

      this.$axios
        .postReq("/meide/REST/ajaxOrderInfo", {
          postType: "queryDistributors",
        })
        .then((res) => {
          this.fxsList = res.data;
        });
    },

    changeStartEnd(val) {
      if (val !== null) {
        this.startTime = val[0];
        this.endTime = val[1];
      } else {
        this.startTime = "";
        this.endTime = "";
      }
    },
  },
  created() {
    this.init();
    this.getList();
  },
  data() {
    return {
      flag: true,
      //产品大类列表
      proClassList: [],
      productClass: "",

      //地址列表
      dizhiList: [],
      shdz: "",

      //销售类别
      leibieList: [],
      sellType: "",
      //分销商
      fxsList: [],
      fxs: "",

      //近期时间
      timeList: [
        {
          id: 1,
          name: "最近一个月",
        },
        {
          id: 2,
          name: "最近三个月",
        },
        {
          id: 3,
          name: "最近六个月",
        },
        {
          id: 4,
          name: "最近一年",
        },
        {
          id: 5,
          name: "更多",
        },
      ],
      timeFlag: "",
      startTime: "",
      endTime: "",
      list: [],
      shortcuts: [
        // {
        //   text: "最近一周",
        //   value: () => {
        //     const end = new Date();
        //     const start = new Date();
        //     start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        //     return [start, end];
        //   },
        // },
        {
          text: "最近一个月",
          value: () => {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            return [start, end];
          },
        },
        {
          text: "最近三个月",
          value: () => {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            return [start, end];
          },
        },
        {
          text: "最近六个月",
          value: () => {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
            return [start, end];
          },
        },
        {
          text: "最近一年",
          value: () => {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
            return [start, end];
          },
        },
      ],
      time: "",
    };
  },
};
</script>